import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const Home = resolve => require(['../pages/Home/Home.vue'], resolve);
const Login = resolve => require(['../pages/Login/login.vue'], resolve);
const Positions = resolve => require(['../pages/Positions/Positions.vue'], resolve);
const Order = resolve => require(['../pages/Order/Order.vue'], resolve);
const OrderDetails = resolve => require(['../pages/Order/OrderDetails.vue'], resolve);
const OrderAdd = resolve => require(['../pages/Order/OrderAdd.vue'], resolve);
const SortingDetails = resolve => require(['../pages/Order/SortingDetails.vue'], resolve);
const SortingAdd = resolve => require(['../pages/Order/SortingAdd.vue'], resolve);
const Sorting = resolve => require(['../pages/Order/Sorting.vue'], resolve);
const Role = resolve => require(['../pages/role/Role.vue'], resolve);
const Menu = resolve => require(['../pages/Menu/Menu.vue'], resolve);
const User = resolve => require(['../pages/User/User.vue'], resolve);
const Product= resolve => require(['../pages/Product/Product.vue'], resolve);
const orderPrint= resolve => require(['../pages/Order/orderPrint.vue'], resolve);
export default new Router({
  mode:'history',
  base:'/',
  routes: [
    {
      path: '/', 
      redirect: '/login'
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/home',
      component: Home,
      children:[
    {
      path: '/positions',
      component: Positions
    },  
    {
      path: '/role',
      component:Role
    },
    {
      path: '/user',
      component:User
    },
    {
      path: '/menu',
      component:Menu
    },
    {
      path: '/order',
      component:Order
    },
    {
      path: '/order/add',
      component:OrderAdd
    },
    {
      path: '/sorting',
      component:Sorting
    },
    {
      path: '/sort/details',
      component:SortingDetails
    },
    {
      path: '/sort/add',
      component:SortingAdd
    },
    {
      path: '/order/details',
      component:OrderDetails
    },
    {
      path: '/product',
      component:Product
    },
      ]
    },
    {
      path: '/order/print',
      component:orderPrint
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js